import "./src/styles/resets.scss";

export const onServiceWorkerUpdateReady = () => window.location.reload();
